export default function() {
  const pageHeader = document.querySelector('.page-header');
  const pageHeaderTop = document.querySelector('.page-header__top');
  const pageHeaderButtons = document.querySelector('.page-header__buttons');
  const dropdownTriggers = document.querySelectorAll('.js-dropdown-trigger');
  let collapseStyleAdded = false;

  window.addEventListener('scroll', () => {
    const scrollTop =
      (window.pageYOffset || document.documentElement.scrollTop) -
      (document.documentElement.clientTop || 0);

    let height = pageHeaderTop.clientHeight;

    if (pageHeaderButtons) {
      height += pageHeaderButtons.clientHeight;
    }

    if (scrollTop > height) {
      if (!collapseStyleAdded) {
        pageHeader.style.transform = `translateY(-${height}px)`;
        pageHeader.classList.add('page-header--collapsed');
        collapseStyleAdded = true;
      }
    } else {
      pageHeader.style.transform = `translateY(-${scrollTop}px)`;
      if (collapseStyleAdded) {
        pageHeader.classList.remove('page-header--collapsed');
        collapseStyleAdded = false;
      }
    }
  });

  window.dispatchEvent(new CustomEvent('scroll'));

  [...dropdownTriggers].forEach(dropdownTrigger => {
    const iframe = dropdownTrigger.querySelector('iframe');
    let src = '';
    let srcAutoplay = '';

    if (iframe) {
      src = iframe.src;
      srcAutoplay = `${src}${src.includes('?') ? '&' : '?'}autoplay=1&rel=0`;
    }

    dropdownTrigger.addEventListener('mouseenter', () => {
      document.documentElement.classList.add('dropdown-menu-open');
      if (iframe) {
        iframe.src = srcAutoplay;
      }
    });

    dropdownTrigger.addEventListener('mouseleave', () => {
      document.documentElement.classList.remove('dropdown-menu-open');
      if (iframe) {
        iframe.src = src;
      }
    });
  });
}
